import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Store } from 'lucide-react';

export function RegisterMerchantFields({ formData, handleChange }) {
  const [industries, setIndustries] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/marketplace/industries`)
      .then(({ data }) => setIndustries(data.industries || []))
      .catch(() => setIndustries([]));
  }, []);

  return (
    <div className="space-y-4 p-4 rounded-lg border border-[#00E676]/20 bg-[#00E676]/5">
      <p className="text-[#00E676] text-xs font-medium flex items-center gap-1.5">
        <Store className="w-3.5 h-3.5" /> Business Information
      </p>
      <div className="space-y-2">
        <Label htmlFor="business_name" className="text-white">Business Name *</Label>
        <Input id="business_name" name="business_name" placeholder="Your Business Name" value={formData.business_name} onChange={handleChange} required
          className="bg-[#000B18] border-white/20 text-white placeholder:text-[#5C7599] focus:border-[#00E5FF]" data-testid="register-business-name" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="industry_id" className="text-white">Industry *</Label>
        <select id="industry_id" name="industry_id" value={formData.industry_id || ''} onChange={handleChange}
          className="w-full h-10 px-3 rounded-md bg-[#000B18] border border-white/20 text-white text-sm focus:border-[#00E5FF] focus:outline-none"
          data-testid="register-industry-select" required>
          <option value="">Select industry...</option>
          {industries.map(ind => (
            <option key={ind.id} value={ind.id}>{ind.name}</option>
          ))}
        </select>
      </div>
      <div className="space-y-2">
        <Label htmlFor="business_address" className="text-white">Business Address</Label>
        <Input id="business_address" name="business_address" placeholder="Street, City, Province" value={formData.business_address} onChange={handleChange}
          className="bg-[#000B18] border-white/20 text-white placeholder:text-[#5C7599] focus:border-[#00E5FF]" data-testid="register-business-address" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="business_description" className="text-white">Business Description</Label>
        <textarea id="business_description" name="business_description" placeholder="What does your business offer?" value={formData.business_description} onChange={handleChange}
          rows={3} className="w-full px-3 py-2 rounded-md bg-[#000B18] border border-white/20 text-white text-sm placeholder:text-[#5C7599] focus:border-[#00E5FF] focus:outline-none resize-none"
          data-testid="register-business-description" />
      </div>
    </div>
  );
}
